{
  "LOGIN": {
    "TITLE": "Login to Chatwoot",
    "EMAIL": {
      "LABEL": "Tölvupóstfang",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Vinsamlegast skrifaðu gilt netfang"
    },
    "PASSWORD": {
      "LABEL": "Lykilorð",
      "PLACEHOLDER": "Lykilorð"
    },
    "API": {
      "SUCCESS_MESSAGE": "Innskráning tókst",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur",
      "UNAUTH": "Notandanafn / lykilorð rangt. Vinsamlegast reyndu aftur"
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Gleymt lykilorð?",
    "CREATE_NEW_ACCOUNT": "Stofna nýjan aðgang",
    "SUBMIT": "Innskráning",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
